import { ReactNode } from 'react'
import { useAuth } from '@/auth/AuthContext'
import type { AccessContext } from '@tandem/schema/permissions'

export function useAccessContext(): AccessContext {
  let { company, companies } = useAuth()
  return {
    memberships: companies.map((c) => ({
      company_id: c.company_id,
      type: c.type,
      role: c.role,
      has_stores: c.has_stores,
    })),
    activeCompanyId: company?.company_id ?? null,
  }
}

export function Can({
  check,
  children,
  fallback = null,
}: {
  check: (ctx: AccessContext) => boolean
  children: ReactNode
  fallback?: ReactNode
}) {
  let ctx = useAccessContext()
  return <>{check(ctx) ? children : fallback}</>
}
